import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a Date object as YYYY-MM-DD in the *local* timezone.
 *
 * Use this instead of `date.toISOString().slice(0, 10)` whenever the Date
 * was constructed from local components (e.g. `new Date(year, month, day)`
 * or an `<input type="date">` value). `toISOString()` converts to UTC first,
 * which shifts the day for anyone east of UTC (e.g. BST +1). See the fix
 * for the availability-block calendar off-by-one issue.
 */
export function ymdLocal(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
